let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aoczY")).then(() => parcelRequire('7zoWf'));